import * as React from "react";
import { Spring, config, animated } from "react-spring";
import styled from "@emotion/styled";
import LottieWrapper from "../../Components/Anim/LottieWrapper";
import { Colors } from "../../Themes";

interface IProps {
  children: React.ReactNode;
}

interface ICardHalfProps {
  primary: boolean;
}

const CardWrapper = styled.div`
  width: 800px;
  height: 500px;
  background: ${Colors.snow};
  border-radius: 3px;
  box-shadow: 0 7px 14px 0 rgba(59, 65, 94, 0.1),
    0 3px 6px 0 rgba(0, 0, 0, 0.07);
`;

const CardHalf = styled(animated.div)`
  width: 50%;
  float: left;
  height: 100%;
  padding: 3rem;
  align-items: center;
  justify-content: center;
  display: flex;
  background: ${(props: ICardHalfProps) =>
    props.primary ? `${Colors.snow}` : `${Colors.cmmsBlue}`};
  & h3 {
    font-size: 15px;
    font-weight: 400;
    text-align: center;
    color: ${Colors.snow};
  }
  & h4 {
    font-size: 15px;
    font-weight: 700;
    text-align: center;
    color: ${Colors.snow};
  }
`;

export default class LoginPanel extends React.Component<IProps> {
  render() {
    return (
      <CardWrapper>
        <CardHalf primary={false}>
          <div>
            <Spring
              delay={1500}
              config={config.slow}
              from={{ opacity: 0 }}
              to={{ opacity: 1 }}
            >
              {props => <h3 style={props}>Prevent downtime...</h3>}
            </Spring>
            <Spring
              delay={2100}
              config={config.slow}
              from={{ opacity: 0 }}
              to={{ opacity: 1 }}
            >
              {props => <h4 style={props}>before it happens</h4>}
            </Spring>
            <Spring
              delay={2400}
              config={config.slow}
              from={{ opacity: 0 }}
              to={{ opacity: 1 }}
            >
              {() => (
                <LottieWrapper
                  loop={true}
                  width={140}
                  height={140}
                  anim={require("../../LottieFiles/spinning_gear_with_check.json")}
                />
              )}
            </Spring>
          </div>
        </CardHalf>
        <CardHalf primary={true}>{this.props.children}</CardHalf>
      </CardWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Layouts/CardLayout.tsx